export type MonkeyBehavior = "idle" | "patrol" | "peek";

export type LevelPoint = {
  x: number;
  y: number;
  isBoss?: boolean;
  hp?: number;
  behavior?: MonkeyBehavior;
  patrolDistance?: number;
  patrolSpeed?: number;
  hideSide?: "left" | "right";
  hasHelmet?: boolean;
  hasIronArmor?: boolean;
  canDodge?: boolean;
};

export type LevelBranch = {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  radius: number;
};

export type TreeCover = {
  x: number;
  y1: number;
  y2: number;
  width: number;
  side: "left" | "right";
};

export const LEVEL_POSITIONS: LevelPoint[][] = [
  // --- BIOME 1: HUTAN RIMBA TROPIS (BABAK 1 - 10) ---
  // Babak 1: Pengenalan dasar bidikan lurus
  [{ x: 210, y: 285, behavior: "idle" }],
  // Babak 2: Pengenalan sudut samping
  [{ x: 130, y: 305, behavior: "idle" }],
  // Babak 3: Monyet mulai berjalan santai (patroli bolak-balik di dahan)
  [{ x: 280, y: 260, behavior: "patrol", patrolDistance: 45, patrolSpeed: 40 }],
  // Babak 4: Monyet berjalan + monyet diam di perhentian atas
  [
    { x: 130, y: 288, behavior: "patrol", patrolDistance: 38, patrolSpeed: 42 },
    { x: 295, y: 215, behavior: "idle" },
  ],
  // Babak 5: Pengenalan monyet nongol-ngumpet (Cilukba!) di balik batang pohon kiri
  [
    { x: 90, y: 280, behavior: "peek", hideSide: "left" },
    { x: 290, y: 225, behavior: "patrol", patrolDistance: 35, patrolSpeed: 40 },
  ],
  // Babak 6: Monyet patroli berhelm batok kelapa + monyet sembunyi di batang pohon kanan
  [
    { x: 110, y: 260, behavior: "patrol", patrolDistance: 42, patrolSpeed: 45, hasHelmet: true },
    { x: 330, y: 235, behavior: "peek", hideSide: "right" },
  ],
  // Babak 7: Taktik ganda pohon kiri & kanan + pengawas lincah bisa menunduk
  [
    { x: 90, y: 300, behavior: "peek", hideSide: "left" },
    { x: 210, y: 210, behavior: "patrol", patrolDistance: 48, patrolSpeed: 48, canDodge: true },
    { x: 330, y: 290, behavior: "peek", hideSide: "right" },
  ],
  // Babak 8: Monyet berhelm batok kelapa di dahan bawah + perangkap ranting
  [
    { x: 105, y: 250, behavior: "patrol", patrolDistance: 40, patrolSpeed: 45 },
    { x: 330, y: 220, behavior: "peek", hideSide: "right" },
    { x: 220, y: 345, behavior: "patrol", patrolDistance: 36, patrolSpeed: 40, hasHelmet: true },
  ],
  // Babak 9: Hutan Rimba Liar - monyet lincah atas bisa menghindar dan sembunyi bergantian
  [
    { x: 90, y: 330, behavior: "peek", hideSide: "left" },
    { x: 330, y: 290, behavior: "peek", hideSide: "right" },
    { x: 210, y: 175, behavior: "patrol", patrolDistance: 50, patrolSpeed: 52, canDodge: true },
  ],
  // Babak 10: Raja Monyet Rimba Bos (HP 3, refleks gesit) + Monyet pengawal sembunyi
  [
    { x: 210, y: 220, isBoss: true, hp: 3, behavior: "patrol", patrolDistance: 55, patrolSpeed: 44, canDodge: true },
    { x: 330, y: 310, behavior: "peek", hideSide: "right" },
  ],

  // --- BIOME 2: GUA MAGMA PURBA & TEBING VULKANIK (BABAK 11 - 20) ---
  // Babak 11: Gerbang Gua Magma — monyet patroli cepat di tebing pilar batu
  [
    { x: 130, y: 270, behavior: "patrol", patrolDistance: 40, patrolSpeed: 48 },
    { x: 290, y: 220, behavior: "idle" },
  ],
  // Babak 12: Pengenalan Monyet Berzirah Besi (Iron Armor) + pengintai pilar
  [
    { x: 210, y: 240, behavior: "patrol", patrolDistance: 45, patrolSpeed: 45, hasIronArmor: true },
    { x: 330, y: 310, behavior: "peek", hideSide: "right" },
  ],
  // Babak 13: Monyet Shinobi Lincah (kecepatan tinggi + menghindar gesit)
  [
    { x: 90, y: 310, behavior: "peek", hideSide: "left" },
    { x: 210, y: 195, behavior: "patrol", patrolDistance: 55, patrolSpeed: 62, canDodge: true },
  ],
  // Babak 14: Sentry Zirah Besi di tengah + 2 pengawal pilar basal
  [
    { x: 90, y: 290, behavior: "peek", hideSide: "left" },
    { x: 210, y: 230, behavior: "idle", hasIronArmor: true },
    { x: 330, y: 270, behavior: "peek", hideSide: "right" },
  ],
  // Babak 15: Badai Abu Vulkanik — patroli zirah bertingkat ganda
  [
    { x: 125, y: 260, behavior: "patrol", patrolDistance: 44, patrolSpeed: 48, hasIronArmor: true },
    { x: 285, y: 200, behavior: "patrol", patrolDistance: 40, patrolSpeed: 52, hasIronArmor: true },
  ],
  // Babak 16: Kombinasi Zirah Besi + Shinobi Lincah + Pengintai
  [
    { x: 90, y: 320, behavior: "peek", hideSide: "left" },
    { x: 210, y: 180, behavior: "patrol", patrolDistance: 52, patrolSpeed: 60, canDodge: true },
    { x: 280, y: 270, behavior: "patrol", patrolDistance: 38, patrolSpeed: 46, hasIronArmor: true },
  ],
  // Babak 17: Koridor Sempit Lava — formasi segitiga tajam
  [
    { x: 110, y: 240, behavior: "patrol", patrolDistance: 38, patrolSpeed: 50, hasHelmet: true },
    { x: 330, y: 230, behavior: "peek", hideSide: "right" },
    { x: 210, y: 320, behavior: "patrol", patrolDistance: 45, patrolSpeed: 52, hasIronArmor: true },
  ],
  // Babak 18: Pengawal Zirah Besi ganda + Shinobi puncak
  [
    { x: 90, y: 290, behavior: "peek", hideSide: "left" },
    { x: 210, y: 210, behavior: "patrol", patrolDistance: 50, patrolSpeed: 62, canDodge: true, hasIronArmor: true },
    { x: 330, y: 310, behavior: "peek", hideSide: "right" },
  ],
  // Babak 19: Pasukan Elit Magma Rimba — 3 target lincah berzirah tebal
  [
    { x: 115, y: 230, behavior: "patrol", patrolDistance: 42, patrolSpeed: 55, hasIronArmor: true },
    { x: 295, y: 210, behavior: "patrol", patrolDistance: 45, patrolSpeed: 56, hasIronArmor: true },
    { x: 210, y: 330, behavior: "patrol", patrolDistance: 48, patrolSpeed: 64, canDodge: true },
  ],
  // Babak 20: FINAL BOSS — KAISAR MONYET PURBA (HP 5, zirah magma, gerak gesit) + 2 pengawal
  [
    { x: 210, y: 215, isBoss: true, hp: 5, behavior: "patrol", patrolDistance: 50, patrolSpeed: 50, canDodge: true, hasIronArmor: true },
    { x: 90, y: 310, behavior: "peek", hideSide: "left" },
    { x: 330, y: 310, behavior: "peek", hideSide: "right" },
  ],
];

export function treeCoversForLevel(level: number): TreeCover[] {
  if (level < 5) return [];
  return [
    { x: 32, y1: 50, y2: 640, width: 66, side: "left" },
    { x: 388, y1: 50, y2: 640, width: 66, side: "right" },
  ];
}

export type FallingBranchConfig = {
  count: number;
  minSpeed: number;
  maxSpeed: number;
  minLength: number;
  maxLength: number;
};

export function fallingBranchConfigForLevel(level: number): FallingBranchConfig {
  if (level <= 1) return { count: 0, minSpeed: 0, maxSpeed: 0, minLength: 0, maxLength: 0 };
  if (level === 2) return { count: 1, minSpeed: 45, maxSpeed: 60, minLength: 90, maxLength: 120 };
  if (level <= 4) return { count: 2, minSpeed: 55, maxSpeed: 75, minLength: 85, maxLength: 115 };
  if (level <= 6) return { count: 3, minSpeed: 65, maxSpeed: 85, minLength: 80, maxLength: 110 };
  if (level <= 8) return { count: 3, minSpeed: 75, maxSpeed: 95, minLength: 80, maxLength: 115 };
  if (level <= 10) return { count: 4, minSpeed: 85, maxSpeed: 110, minLength: 75, maxLength: 110 };
  if (level <= 14) return { count: 4, minSpeed: 95, maxSpeed: 118, minLength: 70, maxLength: 105 };
  if (level <= 18) return { count: 4, minSpeed: 105, maxSpeed: 125, minLength: 70, maxLength: 100 };
  return { count: 5, minSpeed: 110, maxSpeed: 130, minLength: 65, maxLength: 95 };
}

export type WindDirection = "right" | "left" | "down" | "down-right" | "down-left";

export type WindConfig = {
  enabled: boolean;
  waveInterval: number; // Seconds between wind waves
  waveDuration: number; // How long each surge lasts
  gustStrength: number; // Force in px/s^2
  allowedDirections: WindDirection[];
  baseWind: number; // Legacy compatibility
  gustRange: number; // Legacy compatibility
};

export function windConfigForLevel(level: number): WindConfig {
  if (level === 1) {
    return {
      enabled: true,
      waveInterval: 3.0, // Jeda 3 detik
      waveDuration: 2.5, // Hembusan kencang 2.5 detik
      gustStrength: 320, // Kuat dan nyata terasa sesuai fisika
      allowedDirections: ["right", "left"],
      baseWind: 60,
      gustRange: 30,
    };
  }
  if (level === 2) {
    return {
      enabled: true,
      waveInterval: 3.0,
      waveDuration: 2.5,
      gustStrength: 350,
      allowedDirections: ["right", "left"],
      baseWind: 70,
      gustRange: 35,
    };
  }
  if (level <= 4) {
    return {
      enabled: true,
      waveInterval: 3.0,
      waveDuration: 2.6,
      gustStrength: 390,
      allowedDirections: ["right", "left", "down"],
      baseWind: 80,
      gustRange: 40,
    };
  }
  if (level <= 7) {
    return {
      enabled: true,
      waveInterval: 3.0,
      waveDuration: 2.6,
      gustStrength: 430,
      allowedDirections: ["right", "left", "down"],
      baseWind: 90,
      gustRange: 45,
    };
  }
  if (level <= 10) {
    return {
      enabled: true,
      waveInterval: 3.0,
      waveDuration: 2.7,
      gustStrength: 470,
      allowedDirections: ["right", "left", "down"],
      baseWind: 100,
      gustRange: 50,
    };
  }
  if (level <= 14) {
    return {
      enabled: true,
      waveInterval: 3.0,
      waveDuration: 2.7,
      gustStrength: 500,
      allowedDirections: ["right", "left", "down", "down-right", "down-left"],
      baseWind: 110,
      gustRange: 55,
    };
  }
  if (level <= 18) {
    return {
      enabled: true,
      waveInterval: 3.0,
      waveDuration: 2.8,
      gustStrength: 530,
      allowedDirections: ["right", "left", "down", "down-right", "down-left"],
      baseWind: 120,
      gustRange: 60,
    };
  }
  return {
    enabled: true,
    waveInterval: 3.0,
    waveDuration: 2.8,
    gustStrength: 560,
    allowedDirections: ["right", "left", "down", "down-right", "down-left"],
    baseWind: 130,
    gustRange: 65,
  };
}

export type UniqueObstacleKind = "bumper_crystal" | "beehive" | "totem_pillar";

export type UniqueObstacleDef = {
  kind: UniqueObstacleKind;
  x: number;
  y: number;
  anchorX?: number;
  anchorY?: number;
  hp?: number;
};

export function slingshotPositionForLevel(level: number): { x: number; y: number } {
  switch (level) {
    case 1:
      return { x: 210, y: 508 }; // Tengah standar
    case 2:
      return { x: 140, y: 515 }; // Sayap Kiri
    case 3:
      return { x: 280, y: 515 }; // Sayap Kanan
    case 4:
      return { x: 210, y: 535 }; // Cekungan Tengah Rendah
    case 5:
      return { x: 135, y: 475 }; // Tebing Kiri Tinggi
    case 6:
      return { x: 285, y: 510 }; // Sudut Kanan Pesisir
    case 7:
      return { x: 155, y: 525 }; // Kiri Menengah
    case 8:
      return { x: 290, y: 480 }; // Tebing Kanan Tinggi
    case 9:
      return { x: 210, y: 540 }; // Lembah Tengah Rendah
    case 10:
      return { x: 140, y: 495 }; // Ledge Taktis Kiri Arena King Kong
    case 11:
      return { x: 130, y: 520 }; // Batuan Basalt Kiri Vulkanik
    case 12:
      return { x: 285, y: 510 }; // Sisi Kanan Magma
    case 13:
      return { x: 210, y: 545 }; // Cekungan Kawah Vulkanik
    case 14:
      return { x: 125, y: 470 }; // Pilar Obsidian Tinggi Kiri
    case 15:
      return { x: 295, y: 520 }; // Sisi Kanan Tebing Lava
    case 16:
      return { x: 210, y: 478 }; // Batu Apung Magma Tinggi
    case 17:
      return { x: 135, y: 535 }; // Palung Vulkanik Kiri
    case 18:
      return { x: 285, y: 485 }; // Balkon Obsidian Kanan
    case 19:
      return { x: 150, y: 515 }; // Lorong Kawah Kiri
    case 20:
      return { x: 210, y: 500 }; // Altar Tahta Kaisar Monyet Purba
    default:
      return { x: 210, y: 508 };
  }
}

export function uniqueObstaclesForLevel(level: number): UniqueObstacleDef[] {
  switch (level) {
    case 1:
      return [];
    case 2:
      // Sarang lebah berayun di kanan
      return [{ kind: "beehive", x: 275, y: 220, anchorX: 275, anchorY: 90, hp: 2 }];
    case 3:
      // Kristal pemantul pinball di kiri
      return [{ kind: "bumper_crystal", x: 130, y: 250 }];
    case 4:
      // Kombinasi kristal di kanan dan sarang lebah di kiri
      return [
        { kind: "bumper_crystal", x: 290, y: 230 },
        { kind: "beehive", x: 135, y: 280, anchorX: 135, anchorY: 95, hp: 2 },
      ];
    case 5:
      // Pilar batu kuno di tengah
      return [{ kind: "totem_pillar", x: 210, y: 280 }];
    case 6:
      // Kristal pemantul ganda di sisi kiri dan kanan
      return [
        { kind: "bumper_crystal", x: 115, y: 215 },
        { kind: "bumper_crystal", x: 305, y: 245 },
      ];
    case 7:
      // Sarang lebah di tengah dan pilar batu di kanan
      return [
        { kind: "beehive", x: 210, y: 235, anchorX: 210, anchorY: 90, hp: 2 },
        { kind: "totem_pillar", x: 320, y: 310 },
      ];
    case 8:
      // Kristal pemantul di tengah atas dan pilar batu di kiri
      return [
        { kind: "bumper_crystal", x: 210, y: 210 },
        { kind: "totem_pillar", x: 110, y: 290 },
      ];
    case 9:
      // Sarang lebah di kiri dan kristal di kanan
      return [
        { kind: "beehive", x: 145, y: 250, anchorX: 145, anchorY: 90, hp: 2 },
        { kind: "bumper_crystal", x: 275, y: 230 },
      ];
    case 10:
      // Boss King Kong: Pilar batu di tengah dan kristal pemantul di kanan
      return [
        { kind: "totem_pillar", x: 210, y: 285 },
        { kind: "bumper_crystal", x: 330, y: 200 },
      ];
    case 11:
      // Kawah Vulkanik: Kristal geoda magma pemantul di tengah
      return [{ kind: "bumper_crystal", x: 210, y: 230 }];
    case 12:
      // Pilar monolit obsidian di kiri-tengah
      return [{ kind: "totem_pillar", x: 175, y: 260 }];
    case 13:
      // Kristal magma pemantul ganda
      return [
        { kind: "bumper_crystal", x: 125, y: 220 },
        { kind: "bumper_crystal", x: 295, y: 220 },
      ];
    case 14:
      // Pilar obsidian tengah dan sarang lebah vulkanik di kanan
      return [
        { kind: "totem_pillar", x: 210, y: 240 },
        { kind: "beehive", x: 315, y: 280, anchorX: 315, anchorY: 90, hp: 2 },
      ];
    case 15:
      // Kristal magma di tengah dan pilar batu di kiri
      return [
        { kind: "bumper_crystal", x: 210, y: 220 },
        { kind: "totem_pillar", x: 110, y: 280 },
      ];
    case 16:
      // Pilar ganda pelindung monyet lincah
      return [
        { kind: "totem_pillar", x: 140, y: 290 },
        { kind: "totem_pillar", x: 280, y: 290 },
      ];
    case 17:
      // Kristal magma di tengah dan kanan
      return [
        { kind: "bumper_crystal", x: 210, y: 200 },
        { kind: "bumper_crystal", x: 320, y: 260 },
      ];
    case 18:
      // Pilar obsidian tengah dan kristal magma kiri
      return [
        { kind: "totem_pillar", x: 210, y: 270 },
        { kind: "bumper_crystal", x: 120, y: 220 },
      ];
    case 19:
      // Gerbang pertahanan Kaisar: 2 pilar dan 1 kristal bouncer
      return [
        { kind: "totem_pillar", x: 130, y: 250 },
        { kind: "totem_pillar", x: 290, y: 250 },
        { kind: "bumper_crystal", x: 210, y: 190 },
      ];
    case 20:
      // Final Boss Kaisar Monyet Purba: Pilar pelindung + 2 kristal magma pemantul
      return [
        { kind: "totem_pillar", x: 210, y: 290 },
        { kind: "bumper_crystal", x: 110, y: 240 },
        { kind: "bumper_crystal", x: 310, y: 240 },
      ];
    default:
      return [];
  }
}


